"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var get_1 = tslib_1.__importDefault(require("lodash/get"));

var react_1 = require("react");

var joinName_1 = tslib_1.__importDefault(require("./joinName"));

function injectName(name, children, parent) {
  return react_1.Children.map(children, function (child) {
    if (!child || typeof child === 'string' || get_1.default(parent, 'props.name')) return child;
    return react_1.cloneElement(child, {
      children: injectName(name, child.props.children, child),
      name: joinName_1.default(name, child.props.name)
    });
  });
}

exports.default = injectName;